import React from "react";
import { useNavigate } from "react-router-dom";
import "./Internship.css";

const internships = [
    {
        id: 1,
        icon: "🎨",
        title: "Frontend Web Development",
        subtitle: "Website Design & Responsive UI",
        description:
            "Learn to design attractive, responsive and user-friendly websites from scratch.",
        technologies: ["HTML5", "CSS3", "JavaScript", "Bootstrap", "Responsive Design"],
        duration: "1–2 Months",
        fee: "Contact for Fees",
        level: "Beginner Friendly",
    },
    {
        id: 2,
        icon: "⚛️",
        title: "React.js Development",
        subtitle: "Modern Frontend Application Development",
        description:
            "Build dynamic React.js websites using components, hooks, routing and API integration.",
        technologies: ["React.js", "JavaScript ES6+", "React Router", "Hooks", "REST APIs"],
        duration: "1–2 Months",
        fee: "Contact for Fees",
        level: "Basic Web Knowledge",
    },
    {
        id: 3,
        icon: "🌐",
        title: "Website Hosting & Deployment",
        subtitle: "Make Your Website Live",
        description:
            "Learn how to publish websites online, configure domains and hosting, and maintain a live website.",
        technologies: ["Domain Setup", "Web Hosting", "Hostinger", "DNS Basics", "Deployment"],
        duration: "2–4 Weeks",
        fee: "Contact for Fees",
        level: "Practical Training",
    },
    {
        id: 4,
        icon: "☁️",
        title: "Salesforce Administrator",
        subtitle: "CRM Configuration & Administration",
        description:
            "Learn Salesforce CRM administration, data management, access control, reporting and automation.",
        technologies: [
            "Salesforce CRM",
            "Objects & Fields",
            "Reports & Dashboards",
            "Profiles & Permission Sets",
            "Flows",
            "Validation Rules",
        ],
        duration: "1–2 Months",
        fee: "Contact for Fees",
        level: "Beginner Friendly",
    },
    {
        id: 5,
        icon: "💻",
        title: "Salesforce Developer",
        subtitle: "CRM Customization & Development",
        description:
            "Develop custom Salesforce functionality using Apex, Triggers, SOQL and Lightning Web Components.",
        technologies: [
            "Apex Programming",
            "Apex Triggers",
            "SOQL",
            "Lightning Web Components",
            "Salesforce APIs",
            "Automation",
        ],
        duration: "2–3 Months",
        fee: "Contact for Fees",
        level: "Salesforce Fundamentals Recommended",
    },
    {
        id: 6,
        icon: "🧩",
        title: "Full Stack Web Development",
        subtitle: "Frontend, Backend & Database",
        description:
            "Understand the complete web development process and build full-stack applications through practical projects.",
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "Backend Fundamentals",
            "Database Basics",
            "API Integration",
        ],
        duration: "2–3 Months",
        fee: "Contact for Fees",
        level: "Beginner Friendly",
    },
    {
        id: 7,
        icon: "🛠️",
        title: "Software Development",
        subtitle: "Programming & Real-World Projects",
        description:
            "Learn software development fundamentals, debugging, version control and structured project development.",
        technologies: [
            "Programming Fundamentals",
            "JavaScript",
            "Git & GitHub",
            "Debugging",
            "Software Development Lifecycle",
        ],
        duration: "1–3 Months",
        fee: "Contact for Fees",
        level: "Beginner Friendly",
    },
    {
        id: 8,
        icon: "🤖",
        title: "Python & Artificial Intelligence",
        subtitle: "Programming & AI Fundamentals",
        description:
            "Explore Python programming, basic data handling and introductory artificial intelligence concepts.",
        technologies: [
            "Python",
            "Programming Fundamentals",
            "Data Handling Basics",
            "AI Fundamentals",
            "Introductory AI Projects",
        ],
        duration: "1–2 Months",
        fee: "Contact for Fees",
        level: "Beginner Friendly",
    },
];

const Internship = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    const handleEnquiry = (internship) => {
        const message = `Hello A.P Tech Solutions,

I am interested in your ${internship.title} Internship.

Please share the following details:
- Technologies covered
- Internship duration: ${internship.duration}
- Internship fees
- Practical projects and training details
- Internship certificate eligibility

Please provide more information.

Thank you.`;

        window.open(
            `https://wa.me/919426944526?text=${encodeURIComponent(message)}`,
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <div className="internship-page">
            {/* Top Navigation */}
            <nav className="internship-top-nav">
                <button
                    type="button"
                    className="internship-back-btn"
                    onClick={handleBack}
                >
                    ← Back
                </button>

                <button
                    type="button"
                    className="internship-website-btn"
                    onClick={() => navigate("/")}
                >
                    🌐 Visit Website
                </button>
            </nav>

            {/* Hero Section */}
            <section className="internship-hero">
                <div className="internship-hero-content">
                    <span className="internship-tag">
                        A.P TECH SOLUTIONS
                    </span>

                    <h1>
                        Internship & <span>Practical Training</span>
                    </h1>

                    <p>
                        Learn industry-relevant technologies, work on practical
                        projects, develop real-world skills and take your first
                        step towards a career in IT.
                    </p>

                    <div className="internship-hero-points">
                        <span>✓ Practical Learning</span>
                        <span>✓ Technology-Based Training</span>
                        <span>✓ Project Experience</span>
                    </div>

                    <button
                        type="button"
                        className="internship-hero-btn"
                        onClick={() =>
                            document.getElementById("internship-programs")
                                ?.scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Explore Internships <span>→</span>
                    </button>
                </div>
            </section>

            {/* Introduction */}
            <section className="internship-intro">
                <span className="internship-section-label">
                    BUILD YOUR SKILLS
                </span>

                <h2>Choose Your Internship Technology</h2>

                <p>
                    Get introduced to web development, Salesforce CRM,
                    deployment and modern software technologies through
                    structured learning and practical assignments.
                </p>
            </section>

            {/* Internship Cards */}
            <section
                className="internship-programs"
                id="internship-programs"
            >
                {internships.map((internship) => (
                    <article
                        className="internship-card"
                        key={internship.id}
                    >
                        <div className="internship-card-header">
                            <div className="internship-icon">
                                {internship.icon}
                            </div>

                            <span className="internship-level">
                                {internship.level}
                            </span>
                        </div>

                        <h3>{internship.title}</h3>

                        <h4>{internship.subtitle}</h4>

                        <p className="internship-description">
                            {internship.description}
                        </p>

                        <div className="internship-tech-heading">
                            Technologies Covered
                        </div>

                        <div className="internship-tech-list">
                            {internship.technologies.map((technology) => (
                                <span key={technology}>
                                    {technology}
                                </span>
                            ))}
                        </div>

                        <div className="internship-card-info">
                            <div>
                                <span>Duration</span>
                                <strong>{internship.duration}</strong>
                            </div>

                            <div>
                                <span>Fees</span>
                                <strong>{internship.fee}</strong>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="internship-enquiry-btn"
                            onClick={() => handleEnquiry(internship)}
                        >
                            Enquire on WhatsApp
                            <span> ↗</span>
                        </button>
                    </article>
                ))}
            </section>

            {/* Learning Benefits */}
            <section className="internship-benefits">
                <div className="internship-benefits-heading">
                    <span className="internship-section-label">
                        LEARN BY DOING
                    </span>

                    <h2>What You Can Learn</h2>

                    <p>
                        Training activities depend on the selected internship
                        program and its syllabus.
                    </p>
                </div>

                <div className="internship-benefits-grid">
                    <div className="internship-benefit">
                        <span>📚</span>
                        <h3>Technology Fundamentals</h3>
                        <p>
                            Understand the tools and concepts used in your
                            selected technology.
                        </p>
                    </div>

                    <div className="internship-benefit">
                        <span>💡</span>
                        <h3>Practical Assignments</h3>
                        <p>
                            Apply your knowledge through coding exercises
                            and guided tasks.
                        </p>
                    </div>

                    <div className="internship-benefit">
                        <span>🚀</span>
                        <h3>Project Development</h3>
                        <p>
                            Practice developing websites, CRM solutions or
                            software projects based on your program.
                        </p>
                    </div>

                    <div className="internship-benefit">
                        <span>🎯</span>
                        <h3>Career Preparation</h3>
                        <p>
                            Build technical knowledge and discuss how to
                            present your projects in a portfolio.
                        </p>
                    </div>
                </div>
            </section>

            {/* Final CTA */}
            <section className="internship-cta">
                <h2>Ready to Start Your IT Journey?</h2>

                <p>
                    Contact A.P Tech Solutions to discuss the internship
                    syllabus, fees, duration and available training options.
                </p>

                <button
                    type="button"
                    onClick={() => {
                        const message =
                            "Hello A.P Tech Solutions, I would like to know more about your internship programs, technologies, fees and duration.";

                        window.open(
                            `https://wa.me/919426944526?text=${encodeURIComponent(message)}`,
                            "_blank",
                            "noopener,noreferrer"
                        );
                    }}
                >
                    Enquire Now on WhatsApp
                </button>
            </section>

            <footer className="internship-footer">
                © {new Date().getFullYear()} A.P Tech Solutions. All Rights Reserved.
            </footer>
        </div>
    );
};

export default Internship;